












































































































import DropDownLanguages from "@/components/NavLanguage/dropDownLanguages.vue";
import { Component, Vue, Watch } from "vue-property-decorator";
import GenericEdit from '../../core/Generics/GenericEdit';
import User from '../../models/security/user.model';
import UserService from '@/services/user.service';
import BaseVue from '@/core/BaseVue';
import UserResearchCenter from '../../models/security/userResearchCenter.Model';
import researchCenterService from "@/services/researchCenter.service";
import BaseSelectPerson from '@/components/base/baseSelectPerson/baseSelectPerson.vue';
import BaseSelectResearchCenter from "@/components/base/baseSelectResearchCenter/baseSelectResearchCenter.vue";

//import UsuarioService from "@/services/usuario.service";
@Component({
  components: { BaseSelectResearchCenter,BaseSelectPerson }
})
export default class ChangeRolComponent extends BaseVue {
      userService: UserService = new UserService();
        researchCenterService = new researchCenterService();
      loading = false;
  constructor() {
    super();
    
    
    
  }
  active = false;
    model = new UserResearchCenter();
    researchCenters = [];

  //usrService = new UsuarioService();
  get user() {
    return this.$store.state.user;
  }
  mounted(){
      this.getcenterById();
  }
   public getcenterById(){
     this.loading = true;
       this.userService.researchCenterByUser(this.user.id).then(center=>{
           this.researchCenters = center;
       }) .finally(() => {
        this.loading = false;
      });
   }
    public passRolToAnotherUser(){
        this.researchCenterService.passRolToAnotherUser(this.model)
         this.$router.push('/')
         return this.$buefy.notification.open({
          duration: 10000,
          message:
            "Operación exitosa!!! Ya no formas parte de esa Institución",
          type: "is-success",
          hasIcon: true
        });
       
    }
    goToHome(){
         this.$router.push('/')
    }
}
  